import Handlebars from 'handlebars';
import React from 'react';
import { BadgePreviewContext } from '../contexts/BadgePreviewContext';
/**
 * Hook that compiles Badge Template
 *
 * * Use this to compile template for future use with {@link BadgeTemplateFinalSvgPreview}
 * * To just render Badge Template - use {@link BadgeTemplatePreview} instead
 */
export function useBuildBadgeTemplateFinalSvgString({ badgeTemplate, badgeTemplateClassifier, formSettings, account, }) {
    const { onGetTemplateDataForBadgeClassifierImageGeneration, defaultSampleAccountData, defaultFormSettings } = React.useContext(BadgePreviewContext);
    const [badgeTemplateFinalSvg, setBadgeTemplateFinalSvg] = React.useState();
    const [badgeTemplateSvgError, setBadgeTemplateSvgError] = React.useState();
    const accountForTemplateData = account !== null && account !== void 0 ? account : defaultSampleAccountData;
    const formSettingsForTemplateData = formSettings !== null && formSettings !== void 0 ? formSettings : defaultFormSettings;
    const handleError = (err) => {
        var _a;
        const e = err;
        setBadgeTemplateSvgError((_a = e === null || e === void 0 ? void 0 : e.message) !== null && _a !== void 0 ? _a : 'Error compiling SVG');
        setBadgeTemplateFinalSvg(undefined);
    };
    React.useEffect(() => {
        if (!badgeTemplate)
            return;
        try {
            void onGetTemplateDataForBadgeClassifierImageGeneration(badgeTemplateClassifier, {
                formSettings: formSettingsForTemplateData,
                account: accountForTemplateData,
            })
                .then((templateData) => {
                try {
                    const badgeTemplateWithData = Handlebars.compile(badgeTemplate)(templateData);
                    setBadgeTemplateSvgError(undefined);
                    setBadgeTemplateFinalSvg(badgeTemplateWithData);
                }
                catch (err) {
                    // eslint-disable-next-line
                    console.error('Error compiling SVG:', err);
                    handleError(err);
                }
            })
                .catch(handleError);
        }
        catch (err) {
            handleError(err);
        }
    }, [
        badgeTemplate,
        formSettings,
        badgeTemplateClassifier,
        onGetTemplateDataForBadgeClassifierImageGeneration,
        accountForTemplateData,
        badgeTemplateSvgError,
        formSettingsForTemplateData,
    ]);
    return {
        badgeTemplateFinalSvg,
        badgeTemplateSvgError,
    };
}
